export const commonUI = {
  info: '情報',
  email: 'メール',
  password: 'パスワード',
  login: 'ログイン',
  logout: 'ログアウト',
  backToLogin: 'ログインに戻る',
  send: '送信',
  yes: 'はい',
  no: 'いいえ',
  confirm: '確認',
  detail: '詳細',
  address: '住所',
  phone: '電話番号',
  companyPhone: '会社の電話番号',
  contract: '契約',
  company: '会社',
  dashboard: 'ダッシュボード',
  settingInfo: 'プロフィール設定',
  forgotPassword: 'パスワードをお忘れの方',
  resetPassword: 'パスワード再設定',
  changePassword: 'パスワード再設定',
  currentPassword: '現在のパスワード',
  newPassword: '新しいパスワード',
  confirmNewPassword: '新しいパスワード（確認）',
  setNewPassword: '新しいパスワードを設定',
  setNewPasswordCompleted: 'パスワード再設定完了',
  listContract: '契約一覧',
  createContract: '契約新規作成',
  detailContract: '契約詳細',
  updateContract: '契約編集',
  infoContract: '契約情報',
  listCompany: '会社一覧',
  createCompany: '会社新規作成',
  updateCompany: '会社編集',
  detailCompany: '会社詳細',
  infoCompany: '会社情報',
  infoRep: '代表者情報',
  token: 'トークン',
  token2: 'トークン2',
  tokenMaster: 'トークンマスター',
  tokenNormal: 'トークンノーマル',
  token2Normal: 'トークン2ノーマル',
  tokenHistory: 'トークン履歴',
  approvalDate: '承認日付',
  register: '新規登録',
  open: '有効',
  close: '無効',
  edit: '編集',
  save: '保存',
  create: '登録',
  update: '更新',
  back: '戻る',
  history: '履歴 ',
  resetToken: 'トークン再設定',
  applyToken: 'トークン適用',
  curToken: '現在のトークン',
  newToken: '新しいトークン',
  companyName: '会社名',
  companyId: 'ID',
  companyPostCode: '郵便番号',
  companyFax: '会社のFAX',
  fullName: '氏名',
  birthday: '生年月日',
  startDate: '開始日',
  createDate: '作成日',
  endDate: '終了日',
  gender: '性別',
  expiredDate: '有効期限',
  status: 'ステータス',
  scoreIndex: 'インデックススコア',
  task: 'タスク',
  taskKey: 'タスクキー',
  age: '年齢',
  type1: '標準偏差',
  type2: '標準点',
  webhook: 'Webhook',
  settingWebhook: 'Webhookの設定情報',
  infoWebhook: 'Webhook設定',
  editWebhook: 'Webhookの情報更新',
  createWebhook: 'Webhookの新規作成',
  isFlag: 'ステータス',
  urlEndPoint: 'Webhook URL',
  authorization: 'トークン',
  validToken: 'トークンの検証',
  infoUrl: '最終ページURL設定',
  finishUrl: '最終ページURL',
  companyCode: '会社ID',
  contractCode: '契約ID',
  btnCreateWebhook: '新規作成',
  headerName: 'ヘッダー名',
  headerValue: 'ヘッダー値',
  btnAddHeader: 'ヘッダー追加',
};
